import { styled } from '@styles/theme'

import { ParagraphStyles } from './styles'

const Paragraph = styled('p', ParagraphStyles.base)

export { Paragraph }
